import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AppColors } from '../theme/colors';
import { AuthService } from '../services/authService';

export const SuspendedPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = ['admin', 'superadmin'].includes(user?.userType || '');

  // 管理者だけが押せる。投稿する方にはボタンを出さない。
  const handleBackToLogin = async () => {
    try {
      await AuthService.signOut();
      navigate('/admin-login', { replace: true });
    } catch (error) {
      console.error('ログアウトエラー:', error);
      navigate('/admin-login', { replace: true });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
        bgcolor: AppColors.surface,
      }}
    >
      <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 1, color: 'black' }}>
        サービス利用が停止されています
      </Typography>
      <Typography sx={{ fontSize: 14, color: AppColors.textSecondary, mb: 3, textAlign: 'center' }}>
        {isAdmin ? (
          <>
            お支払い状況の確認が取れていないため、現在サービスをご利用いただけません。<br />
            恐れ入りますが、お支払い状況のご確認をお願いいたします。<br />
            <Typography component="span" sx={{ fontSize: 12, color: AppColors.textSecondary, mt: 1, display: 'block' }}>
              ※お支払い方法や処理状況により、反映までにお時間がかかる場合があります。
            </Typography>
          </>
        ) : (
          <>
            現在、システム上の都合により、サービスをご利用いただけません。<br />
            恐れ入りますが、本件の詳細につきましては、貴社のシステム管理者までお問い合わせください。
          </>
        )}
      </Typography>
      {/*
        投稿する方にはボタンを置かない。QR・専用URLから入るためログイン画面が
        なく、押した先で「URLが使えません」と出て原因を取り違えさせてしまう。
        できるのは管理者へ問い合わせることだけで、それは本文で伝えている。
      */}
      {isAdmin && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            onClick={() => navigate('/admin/company-management')}
            sx={{ bgcolor: AppColors.primary, color: 'white' }}
          >
            請求書を確認
          </Button>
          <Button variant="outlined" onClick={handleBackToLogin}>
            ログインへ戻る
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SuspendedPage;


